<div class="table-responsive margin-top-15 table-view">
  <h5 class="table-title">Observation / Interventions</h5>
  <button [disabled]="DisableExport"
    class="btn btn-primary primary-btn button-excel"
    style="margin-bottom: 10px"
    (click)="exportToExcel()"
  >
    <i class="fa fa-file-excel-o"></i>Export To Excel
  </button>
  <p-table
    [value]="safetyObsData"
    [scrollable]="false"
    scrollHeight="500px"
    dataKey="Id"
    editMode="row"
    id="ObservationTableToExport"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 220px">Unit</th>
        <th class="center-table" style="width: 80px">Jan</th>
        <th class="center-table" style="width: 80px">Feb</th>
        <th class="center-table" style="width: 80px">Mar</th>
        <th class="center-table" style="width: 80px">Apr</th>
        <th class="center-table" style="width: 80px">May</th>
        <th class="center-table" style="width: 80px">Jun</th>
        <th class="center-table" style="width: 80px">Jul</th>
        <th class="center-table" style="width: 80px">Aug</th>
        <th class="center-table" style="width: 80px">Sep</th>
        <th class="center-table" style="width: 80px">Oct</th>
        <th class="center-table" style="width: 80px">Nov</th>
        <th class="center-table" style="width: 80px">Dec</th>
        <th class="center-table" style="width: 100px">Total</th>
        <th class="center-table" style="width: 100px">Actions</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-observation
      let-editing="editing"
      let-ri="rowIndex"
    >
      <tr [pEditableRow]="observation">
        <td style="width: 220px !important">
          {{ observation.category }}
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observation.Jan"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetSafetyObservationSelectedDetails(
                    observation.UnitId,
                    observation.category,
                    1
                  )
                "
                data-target="#AT"
              >
                {{ observation.Jan }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observation.Feb"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetSafetyObservationSelectedDetails(
                    observation.UnitId,
                    observation.category,
                    2
                  )
                "
                data-target="#AT"
              >
                {{ observation.Feb }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observation.Mar"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetSafetyObservationSelectedDetails(
                    observation.UnitId,
                    observation.category,
                    3
                  )
                "
                data-target="#AT"
              >
                {{ observation.Mar }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observation.Apr"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetSafetyObservationSelectedDetails(
                    observation.UnitId,
                    observation.category,
                    4
                  )
                "
                data-target="#AT"
              >
                {{ observation.Apr }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observation.May"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetSafetyObservationSelectedDetails(
                    observation.UnitId,
                    observation.category,
                    5
                  )
                "
                data-target="#AT"
              >
                {{ observation.May }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observation.Jun"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetSafetyObservationSelectedDetails(
                    observation.UnitId,
                    observation.category,
                    6
                  )
                "
                data-target="#AT"
              >
                {{ observation.Jun }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observation.Jul"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetSafetyObservationSelectedDetails(
                    observation.UnitId,
                    observation.category,
                    7
                  )
                "
                data-target="#AT"
              >
                {{ observation.Jul }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observation.Aug"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetSafetyObservationSelectedDetails(
                    observation.UnitId,
                    observation.category,
                    8
                  )
                "
                data-target="#AT"
              >
                {{ observation.Aug }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observation.Sep"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetSafetyObservationSelectedDetails(
                    observation.UnitId,
                    observation.category,
                    9
                  )
                "
                data-target="#AT"
              >
                {{ observation.Sep }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observation.Oct"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetSafetyObservationSelectedDetails(
                    observation.UnitId,
                    observation.category,
                    10
                  )
                "
                data-target="#AT"
              >
                {{ observation.Oct }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observation.Nov"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetSafetyObservationSelectedDetails(
                    observation.UnitId,
                    observation.category,
                    11
                  )
                "
                data-target="#AT"
              >
                {{ observation.Nov }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observation.Dec"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetSafetyObservationSelectedDetails(
                    observation.UnitId,
                    observation.category,
                    12
                  )
                "
                data-target="#AT"
              >
                {{ observation.Dec }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <a
            data-toggle="modal"
            pTooltip="Get Details"
            tooltipPosition="top"
            (click)="
              GetSafetyObservationSelectedDetails(
                observation.UnitId,
                observation.category,
                13
              )
            "
            data-target="#AT"
          >
            {{ observation.Total }}</a
          >
        </td>
        <td style="text-align: center">
          <button
            *ngIf="!editing"
            pButton
            pRipple
            type="button"
            pInitEditableRow
            icon="pi pi-pencil"
            (click)="onRowEditInit(observation)"
            class="p-button-rounded p-button-text"
          ></button>
          <button
            *ngIf="editing"
            pButton
            pRipple
            type="button"
            pSaveEditableRow
            icon="pi pi-check"
            (click)="onRowEditSave(observation, ri)"
            class="p-button-rounded p-button-text p-button-success p-mr-2"
          ></button>
          <button
            *ngIf="editing"
            pButton
            pRipple
            type="button"
            pCancelEditableRow
            icon="pi pi-times"
            (click)="onRowEditCancel(observation, ri)"
            class="p-button-rounded p-button-text p-button-danger"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div
  class="modal fade PDModal"
  data-backdrop="static"
  style="opacity: 1 !important"
  id="AT"
  role="dialog"
>
  <div class="modal-dialog custom-modal">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close button-cancel" data-dismiss="modal">
          &times;
        </button>
        <!-- <h4 class="modal-title custom_align" id="Heading">Risk Assessment Matrix</h4> -->
      </div>
      <div class="modal-body">
        <!-- <img class="ram-img" src="assets/images/incident-ram.png" /> -->
        <ol id="liPDheight">
          <ng-container *ngFor="let item of SafObsData; let i = index">
            <li>
              <a (click)="Redirect(item.value, item.ID)">{{ item.Text }}</a>
            </li>
          </ng-container>
        </ol>
        <span *ngIf="SafObsData?.length < 1" style="color: red"
          >No Records Found..</span
        >
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>
